import { render, staticRenderFns } from "./TheWindowAsideLeft.vue?vue&type=template&id=797128b8&scoped=true"
import script from "./TheWindowAsideLeft.vue?vue&type=script&lang=js"
export * from "./TheWindowAsideLeft.vue?vue&type=script&lang=js"
import style0 from "./TheWindowAsideLeft.vue?vue&type=style&index=0&id=797128b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797128b8",
  null
  
)

export default component.exports